<template>
  <div class="content">
    <van-nav-bar title="订单详情" border fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#000" />
      </template>
    </van-nav-bar>

    <div class="order-status">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <div class="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center mr-3">
            <i class="fas fa-utensils text-green-500"></i>
          </div>
          <div>
            <div class="dining-status">{{ orderModel.orderStatusName }}</div>
            <div class="dining-info">订单已下，用餐愉快！</div>
          </div>
        </div>
        <div class="status-name" :class="!orderModel.remainAmount ? 'done' : 'paying'">
          {{ orderModel.paymentStatusName }}
        </div>
      </div>
      <div class="flex justify-between text-sm text-gray-500 mt-4">
        <span>订单号: {{ orderModel.orderNo }}</span>
        <span>下单: {{ orderModel.createTime }}</span>
      </div>
      <div
        v-if="orderModel.tableName === '自提'"
        class="flex justify-between text-sm text-gray-500 mt-2"
      >
        <span>自提时间: {{ orderModel.selfPickDate }} {{ orderModel.selfPickTime }}</span>
      </div>
    </div>

    <div class="restaurant">
      <div class="flex items-center">
        <div>
          <img
            src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80"
            alt="餐厅图片"
            class="restaurant-img"
          />
        </div>
        <div class="restaurant-info">
          <div class="restaurant-name">{{ orderModel.shopName }}</div>
          <div class="flex items-center text-xs text-gray-500">
            <span>桌号: {{ orderModel.tableName }}</span>
            <span class="mx-2">|</span>
            <span>用餐人数: {{ orderModel.personCount }}人</span>
          </div>
        </div>
      </div>
    </div>

    <div class="order-content">
      <div class="order-title-container">
        <h2 class="order-title">订单内容</h2>
      </div>

      <div class="order-list">
        <div
          v-for="(item, index) in orderModel.foodList?.filter((i) => i.addType === 1)"
          :key="index"
          class="order-item"
        >
          <div class="flex justify-between">
            <div class="text-left">
              <span class="order-item-name">{{ item.foodName }}</span>
              <span class="order-item-spec"
                >{{ item.foodSpecName }}
                {{ item.foodCookDesc ? `| ${item.foodCookDesc}` : '' }}</span
              >
            </div>
            <div class="text-right">
              <span class="order-item-price">¥{{ item.price }}</span>
              <span class="order-item-qty">x{{ item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="(orderModel.foodList?.filter((i) => i.addType === 2) || []).length > 0"
        class="order-add-list"
      >
        <div class="order-add-food">
          <van-icon name="plus" color="#ee0a24" />
          <span class="order-add-food-title">加菜</span>
        </div>
        <div
          v-for="(item, index) in orderModel.foodList?.filter((i) => i.addType === 2)"
          :key="index"
          class="order-item"
        >
          <div class="flex justify-between">
            <div class="text-left">
              <span class="order-item-name">{{ item.foodName }}</span>
              <span class="order-item-spec"
                >{{ item.foodSpecName }}
                {{ item.foodCookDesc ? `| ${item.foodCookDesc}` : '' }}</span
              >
            </div>
            <div class="text-right">
              <span class="order-item-price">¥{{ item.price }}</span>
              <span class="order-item-qty">x{{ item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="orderModel.seatNumber || orderModel.bookTime" class="order-fee">
      <div v-if="orderModel.seatNumber" class="flex justify-between mb-1">
        <span class="text-gray-600">座位号</span>
        <span>{{ orderModel.seatNumber }}</span>
      </div>
      <div v-if="false && orderModel.bookTime" class="flex justify-between">
        <span class="text-gray-600">预定时间</span>
        <span>{{ orderModel.bookTime }}</span>
      </div>
    </div>

    <div class="order-fee">
      <div class="flex justify-between mb-2">
        <span class="text-gray-600">商品小计</span>
        <span>¥{{ orderModel.foodAmount }}</span>
      </div>
      <div class="flex justify-between mb-2">
        <span class="text-gray-600">打包费</span>
        <span>¥{{ orderModel.packageAmount }}</span>
      </div>
      <div v-if="false" class="flex justify-between text-red-500">
        <span>优惠券</span>
        <span>-¥{{ orderModel.discountAmount }}</span>
      </div>
      <div class="actual-amount">
        <span>总金额</span>
        <span class="text-red-500">¥{{ orderModel.totalAmount }}</span>
      </div>
      <div class="flex justify-between" style="margin-top: 5px">
        <span>已支付</span>
        <span>¥{{ orderModel.paymentAmount }}</span>
      </div>
    </div>

    <div class="order-remark">
      <div class="remark">备注</div>
      <div class="desc">{{ orderModel.remark }}</div>
    </div>

    <div v-if="false" class="order-invoice">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <div class="order-invoice-img">
            <i class="fas fa-receipt text-blue-500"></i>
          </div>
          <div class="invoice-info">
            <div class="invoice-title">开具发票</div>
            <div class="invoice-desc">可为本次消费申请电子发票</div>
          </div>
        </div>
        <i class="fas fa-chevron-right" style="color: #9ca3af"></i>
      </div>
    </div>

    <div v-if="!!orderModel.remainAmount" class="bottom">
      <div class="order-amount">
        <div class="order-amount-info">
          <div class="total-amount-text">
            <span class="text-gray-600">需支付:</span>
            <span class="order-actual-amount">¥{{ orderModel.remainAmount }}</span>
          </div>
          <div @click="handleShowAA">
            <van-image width="30" height="30" src="/images/AA.png" />
          </div>
        </div>
        <div class="payment-remark">用餐结束后请完成支付</div>
      </div>
      <button v-if="paymentLine === 1" class="ios-button" @click="handleStartPayment">
        立即支付
      </button>
    </div>
  </div>
  <van-dialog
    v-model:show="displayIosPaymentDialog"
    title=" "
    show-cancel-button
    @confirm="confirmPay"
  >
    <div
      style="display: flex; flex-direction: column; justify-content: center; align-items: center"
    >
      <van-image
        width="100"
        fit="contain"
        src="https://gw.alipayobjects.com/mdn/rms_7e962d/afts/img/A*yCL8TrkjIx8AAAAAAAAAAAAAARQnAQ"
        class="restaurant-image"
        style="text-align: center"
      />
      <div style="text-align: center; line-height: 24px; color: blue; padding: 15px"
        >是否跳转至支付宝页面</div
      ></div
    >
  </van-dialog>

  <van-dialog
    v-model:show="displayAADialog"
    :show-confirm-button="false"
    class="order-success-dialog"
  >
    <div class="dialog-content">
      <van-icon name="close" class="close-icon" @click="displayAADialog = false" />
      <div class="success-title">计算AA金额</div>
      <van-divider :style="{ borderColor: '#979da1', padding: '0 16px', width: '100%' }" />
      <div class="order-info">
        <div class="info-row">
          <span>支付金额</span>
          <span>{{ orderModel.remainAmount }}</span>
        </div>
        <div class="info-row">
          <span>用餐人数</span>
          <span>
            <van-stepper v-model="diners" @change="handleDinersChange" />
          </span>
        </div>
        <div class="info-row">
          <span>人均</span>
          <span> ￥{{ aaAmount }} </span>
        </div>
      </div>
      <div class="dialog-buttons">
        <van-button
          round
          block
          :color="h5Config.themeColor"
          class="dialog-button"
          @click="calculateAmount"
        >
          计算
        </van-button>
      </div>
    </div>
  </van-dialog>
</template>

<script setup lang="ts">
  import { onMounted, ref, computed, reactive } from 'vue';
  import h5Config from '@/config/config';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { getOrder } from '@/service/order';
  import { OrderDetailModel } from '@/model/order';
  import { startPayment } from '@/service/payment';
  import { fetchShopList } from '@/service/base';
  import { showDialog } from 'vant';

  const route = useRoute();
  const orderId = ref(0);
  const orderModel = ref<OrderDetailModel>({});

  const paymentLine = ref<number>(0);
  const paymentTime = ref('');
  const errorMessage = ref('');
  const paymentPollingInterval = ref(null);
  const paymentTimeout = ref(null);
  const paymentWindow = ref(null);
  const displayIosPaymentDialog = ref(false);
  const state = reactive({
    payUrl: '' as string | undefined,
  });
  const displayAADialog = ref(false);
  const diners = ref<number>(1);
  const aaAmount = ref('');

  onMounted(async () => {
    orderId.value = Number(route.params.id || 0);
    await loadOrder();
    loadShop();
  });

  const loadOrder = async () => {
    const res = await getOrder({ orderId: orderId.value });
    orderModel.value = res.result || {};
  };

  const loadShop = async () => {
    const response = await fetchShopList({
      pageNum: 1,
      pageSize: 100,
      data: { shopStatus: 0 },
    });
    if (response.code === 200) {
      const shop = response.result.list.find((item) => item.shopId === orderModel.value.shopId);
      if (shop) {
        paymentLine.value = shop.paymentLine;
      } else {
        showDialog({ message: '店铺不存在' });
      }
    }

    console.log('paymentLine', paymentLine.value);
  };

  // 设备检测
  const isIOS = computed(() => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  });

  const isWeChatBrowser = computed(() => {
    return /MicroMessenger/i.test(navigator.userAgent);
  });

  const handleStartPayment = async () => {
    try {
      const response = await startPayment({
        orderId: orderModel.value.orderId,
        paymentMethod: 2,
        amount: orderModel.value.remainAmount,
        openId: 'openId',
        returnUrl:
          window.location.origin +
          '/payment/alipay/result?orderId=' +
          orderModel.value.orderId +
          '&orderNo=' +
          orderModel.value.orderNo +
          '&paymentMethod=2',
      });
      if (response.code === 200) {
        const payUrl = response.result.request;
        const paymentNo = response.result.paymentNo;
        console.log(payUrl);
        state.payUrl = payUrl;
        if (payUrl) {
          // 根据不同设备采用不同支付策略
          if (isIOS.value) {
            // showToast('ios');
            displayIosPaymentDialog.value = true;
          } else {
            startNormalPayment(payUrl);
          }
        }
      }
    } catch (error) {
      handlePaymentError('支付请求失败，请重试');
    }
  };

  const confirmPay = () => {
    startIOSPayment(state.payUrl, orderModel.value.orderId);
  };

  // iOS设备支付策略
  const startIOSPayment = (payUrl, orderId) => {
    try {
      window.location.href = payUrl;
      // window.open(payUrl, '_blank');
    } catch (error) {
      console.error('iOS支付启动失败:', error);
      handlePaymentError('支付启动失败，请重试');
    }
  };

  // 普通设备支付策略
  const startNormalPayment = (payUrl) => {
    // paymentWindow.value = window.open(payUrl, '_blank');
    window.location.href = payUrl;

    // 监控支付窗口是否关闭
    // const winTimer = setInterval(() => {
    //   if (paymentWindow.value && paymentWindow.value.closed) {
    //     clearInterval(winTimer);
    //   }
    // }, 1000);
  };

  // 检查支付状态
  const checkPaymentStatus = async (orderId) => {
    // 这里应该调用实际的API
    // 示例: return await api.checkPaymentStatus({ orderId });

    // 临时模拟API调用
    return new Promise((resolve) => {
      setTimeout(() => {
        // 模拟API响应
        resolve({
          code: 200,
          result: {
            status: 'SUCCESS', // 或 'FAILED', 'PROCESSING'
          },
        });
      }, 500);
    });
  };

  // 处理支付成功
  const handlePaymentSuccess = () => {
    // 关闭支付窗口（如果存在）
    if (paymentWindow.value && !paymentWindow.value.closed) {
      paymentWindow.value.close();
    }

    // 记录支付时间
    paymentTime.value = new Date().toLocaleString();
  };

  // 处理支付超时
  const handlePaymentTimeout = () => {
    // 关闭支付窗口（如果存在）
    if (paymentWindow.value && !paymentWindow.value.closed) {
      paymentWindow.value.close();
    }

    // 清除存储的状态
    sessionStorage.removeItem('paymentInProgress');
    sessionStorage.removeItem('paymentOrderId');

    handlePaymentError('支付超时，请重新尝试');
  };

  // 处理支付错误
  const handlePaymentError = (message) => {
    // pageState.value = 'payment';
    // paymentInProgress.value = false;
    errorMessage.value = message;
  };

  // 处理页面可见性变化
  const handleVisibilityChange = () => {
    // 当页面从隐藏变为可见时（用户从支付页面返回）
    if (document.visibilityState === 'visible') {
      // 检查是否有正在进行的支付
      const paymentInProgress = sessionStorage.getItem('paymentInProgress') === 'true';

      if (paymentInProgress) {
        console.log('用户从支付页面返回，检查支付状态');
        // 立即检查一次支付状态
        checkPaymentStatus(orderModel.value.orderId).then((response) => {
          if (response.code === 200) {
            const status = response.result.status;

            if (status === 'SUCCESS') {
              handlePaymentSuccess();
            } else if (status === 'FAILED') {
              handlePaymentError('支付失败，请重试');
            }
          }
        });
      }
    }
  };

  const onClickLeft = () => {
    router.replace('/order');
  };

  const handleShowAA = () => {
    displayAADialog.value = true;
  };

  const calculateAmount = () => {
    aaAmount.value = (Number(orderModel.value.remainAmount || 0) / diners.value).toFixed(2);
  };

  const handleDinersChange = (e: any) => {
    calculateAmount();
  };
</script>

<style scoped lang="less">
  .content {
    padding: 10px;

    .flex {
      display: flex;
    }

    .column {
      flex-direction: column;
    }

    .items-center {
      align-items: center;
    }

    .justify-between {
      justify-content: space-between;
    }

    .bg-white {
      background-color: #fff;
    }

    .p-4 {
      padding: 16px;
    }

    .mb-3 {
      margin-bottom: 8px;
    }

    .mb-2 {
      margin-bottom: 10px;
    }

    .mb-1 {
      margin-bottom: 6px;
    }

    .text-gray-500 {
      color: #6b7280;
    }

    .navigation {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      padding: 2px 16px;

      .text-yellow-600 {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #d97706;

        .mr-1 {
          margin-right: 6px;
        }
      }

      h1 {
        font-size: 18px;
        line-height: 28px;
        font-weight: 600;
      }

      .title {
        font-size: 18px;
        line-height: 28px;
        font-weight: 600;
      }
    }

    .order-status {
      background-color: #fff;
      padding: 16px;
      margin-top: 48px;

      .bg-green-50 {
        background-color: #dcfce7;
      }

      .justify-center {
        justify-content: center;
      }

      .w-10 {
        width: 40px;
      }

      .h-10 {
        height: 40px;
      }

      .rounded-full {
        border-radius: 9999px;
      }

      .mr-3 {
        margin-right: 12px;
      }

      .text-green-500 {
        color: #16a34a;
      }

      .text-lg {
        font-size: 18px;
        line-height: 28px;
        text-align: left;
      }

      .text-sm {
        font-size: 14px;
        line-height: 20px;
      }

      .dining-status {
        font-size: 18px;
        line-height: 28px;
        font-weight: 700;
        text-align: left;
      }

      .dining-info {
        font-size: 14px;
        line-height: 20px;
      }

      .status-name {
        font-size: 14px;
        line-height: 20px;
        color: #ef4444;
        padding: 4px 12px;
        background-color: #fef2f2;
        border-radius: 10px;
      }

      .waiting {
        color: #3b82f6;
        background-color: #eef3f9;
      }

      .paying {
        color: #dc2626;
        background-color: #fef2f2;
      }

      .done {
        color: #059669;
        background-color: #eaf5f3;
      }

      .mt-4 {
        margin-top: 16px;
      }

      .mt-2 {
        margin-top: 8px;
      }
    }

    .restaurant {
      background-color: #fff;
      padding: 16px;
      margin-top: 10px;

      .restaurant-img {
        width: 48px;
        height: 48px;
        border-radius: 8px;
      }

      .restaurant-info {
        margin-left: 12px;

        .restaurant-name {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          text-align: left;
        }

        .text-xs {
          font-size: 12px;
          line-height: 16px;
        }

        .mx-2 {
          margin: 0 8px;
        }
      }
    }

    .order-content {
      background-color: #fff;
      padding: 16px;
      margin-top: 10px;

      .order-title-container {
        border-bottom: 1px solid #f3f4f6;
        padding-bottom: 10px;
        text-align: left;

        h2 {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          margin: 0;
        }
      }

      .order-item {
        margin-top: 8px;
        margin-bottom: 8px;
      }

      .order-item:last-child {
        margin-bottom: 0;
      }

      .order-item-name {
        display: block;
        font-weight: 500;
        font-size: 15px;
        margin-bottom: 2px;
      }

      .order-item-spec {
        display: block;
        font-size: 12px;
        color: #6b7280;
      }

      .order-item-price {
        display: block;
        font-weight: 500;
        color: #ef4444;
        margin-bottom: 2px;
      }

      .order-item-qty {
        display: block;
        font-size: 12px;
        color: #6b7280;
      }

      .text-left {
        text-align: left;
      }

      .text-right {
        text-align: right;
      }

      .order-add-list {
        margin-top: 10px;
        border-top: 1px solid #f3f4f6;
        padding-top: 10px;

        .order-add-food {
          text-align: left;
          font-weight: 600;
        }
      }
    }

    .order-fee {
      background-color: #fff;
      padding: 16px;
      margin-top: 10px;

      .actual-amount {
        display: flex;
        justify-content: space-between;
        font-weight: 700;
        font-size: 16px;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #f3f4f6;
      }

      .text-gray-600 {
        color: #4b5563;
      }

      .text-red-500 {
        color: #ef4444;
      }
    }

    .order-remark {
      background-color: #fff;
      padding: 16px;
      margin-top: 10px;
      text-align: left;

      .remark {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 4px;
      }

      .desc {
        font-size: 14px;
        line-height: 20px;
        color: #6b7280;
      }
    }

    .order-invoice {
      background-color: #fff;
      padding: 16px;
      margin-top: 10px;
      margin-bottom: 100px;

      .order-invoice-img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        background-color: #eff6ff;
        border-radius: 9999px;
        color: #3b82f6;
      }

      .text-blue-500 {
        color: #3b82f6;
      }

      .invoice-info {
        text-align: left;
        margin-left: 12px;

        .invoice-title {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          margin-bottom: 2px;
        }

        .invoice-desc {
          font-size: 14px;
          line-height: 20px;
          color: #6b7280;
        }
      }
    }

    .bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 28px;
      z-index: 99;
      background-color: #fff;
      padding: 12px 16px;
      border: none;
      border-top: 1px solid #e5e7eb;

      .order-amount {
        flex: 1;
        text-align: left;

        .order-amount-info {
          display: flex;
          font-size: 14px;
          line-height: 20px;
          color: #4b5563;
          margin-bottom: 4px;

          .total-amount-text {
            margin-right: 10px;
          }
        }

        .order-actual-amount {
          color: #ef4444;
          font-size: 20px;
          font-weight: 700;
          line-height: 28px;
          margin-left: 4px;
        }

        .payment-remark {
          font-size: 12px;
          line-height: 16px;
          color: #6b7280;
        }
      }

      .ios-button {
        background-color: v-bind('h5Config.themeColor');
        color: white;
        border-radius: 12px;
        padding: 12px 20px;
        font-weight: 600;
        width: auto;
        display: inline-block;
        border: none;
        font-size: 16px;
      }
    }
  }

  /* 下单成功弹窗样式 */
  .order-success-dialog {
    width: 80%;
    border-radius: 16px;
    padding: 24px;
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
  }

  .close-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 20px;
    color: #999;
    cursor: pointer;
    z-index: 10;
    padding: 4px;

    /* 添加悬停效果 */
    &:hover {
      color: #333;
      background: #f5f5f5;
      border-radius: 50%;
    }
  }

  .dialog-title {
    font-size: 16px;
    font-weight: bold;
    margin: 15px 0 10px 0;
  }

  .spec-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 15px;
  }

  .success-title {
    font-size: 20px;
    font-weight: bold;
    margin: 16px 0 8px;
  }

  .success-subtitle {
    font-size: 16px;
    color: #6b7280;
    margin-bottom: 16px;
  }

  .order-info {
    width: 100%;
    margin: 16px 0;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .dialog-buttons {
    width: 100%;
    margin-top: 16px;
  }

  .dialog-button {
    height: 44px;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
  }
</style>
